module.exports = __webpack_public_path__ + "img/wx-download.f0aaa148.png";